import {
  BusinessType,
  TimeDuration,
  AnnualBusinessIncome,
  BusinessNeeds
} from '../../constants';
import { FieldTypes } from '../../components/FormBuilder';
import { getHundredYearFloor, getToday } from '../../helpers/dateBounds';
export const formInitialValues = {

};

export const loanAmount = {
  type: 'text',
  inputMode: 'number',
  name: 'loanAmount',
  placeholder: 'How much do you need?',
  disabled: false,
  dark: false,
  hideUnderline: true,
  hint: 'R10 000 000 or R1 500 000'
};

export const financeReason = {
  placeholder: 'What do you need it for?',
  name: 'financeReason',
  options: BusinessNeeds,
  scrollToTop: false
};

export const financeTenure = {
  placeholder: 'How long do you need it for?',
  name: 'financeTenure',
  options: TimeDuration,
  scrollToTop: false
};

export const businessType = {
  placeholder: 'How is your business registered?',
  name: 'businessType',
  options: BusinessType,
  scrollToTop: false
};

export const moveInDate = {
  showOnlyMonthYear: true,
  label: 'How long have you been in business?',
  name: 'timeInBusiness',
  dateFormat: 'yyyy/MM',
  // Functions, not literals: FormBuilder resolves these per render so the bounds
  // cannot go stale in a long-lived session (FSL-19280 AC2).
  minDate: () => getHundredYearFloor(),
  maxDate: () => getToday()
};

export const revenue = {
  placeholder: 'What is your annual business income?',
  name: 'revenue',
  options: AnnualBusinessIncome,
  scrollToTop: false
};

export const formFields = [
  {
    type: FieldTypes.CURRENCYINPUT,
    props: loanAmount
  },
  {
    type: FieldTypes.SELECT,
    props: financeReason
  },
  {
    type: FieldTypes.SELECT,
    props: financeTenure
  },
  {
    type: FieldTypes.SELECT,
    props: businessType
  },
  {
    type: FieldTypes.DATESELECTOR,
    props: moveInDate
  },
  {
    type: FieldTypes.SELECT,
    props: revenue
  }
];
